/* eslint-disable react/no-unescaped-entities */
import React from "react";

export const CRBAgreement = () => {
  return (
    <>
      <div className="terms-of-service crb-terms">
        <p>
          This agreement ("Agreement") is the contract between you, the
          depositor ("you") and Cross River Bank, a New Jersey State Chartered
          Bank ("Bank", "CRB", "we", "us", "our"), that governs your Icon demand
          deposit Account ("Account" or "Accounts"). The Icon Savings
          Corporation (d.b.a. Icon Savings Plan, "Icon", and its affiliate Icon
          Financial Services LLC, "IFS") is not a bank -- it is a financial
          technology company, and is acting as a service provider that performs
          certain services related to your Account on Cross River Bank's behalf.
        </p>

        <p>
          This Agreement explains how your Account works, what fees are
          applicable to your Account, how the various services work, and the
          policies, and terms and conditions that govern your Account. By
          accepting this Agreement, submitting an application for an Account, or
          by using any of the Bank's deposit account services, you agree to the
          terms in this Agreement.
        </p>

        <p>
          Access to your Account under this Agreement is available via the Icon
          website. Icon is responsible for making the website and other products
          and services on the website available to you and as a result, you
          should carefully review this Agreement and your agreement with Icon.
          Other products or services offered by Icon in connection with the
          Account via the website may have additional agreements that you will
          be required to accept, and you should carefully review those prior to
          entering into any transactions. This Agreement also refers to and
          includes other disclosures including the Truth in Savings Account
          Disclosure, Electronic Fund Transfer Agreement and Disclosure, Fee
          Schedule, Funds Availability Policy, and our Privacy Policy, which are
          incorporated by reference. Please read this Agreement carefully and
          keep a copy for your records.
        </p>

        <h2>I. Definitions</h2>

        <p>
          When used in this Agreement, the following terms have the meanings
          provided below. Defined terms apply equally to the singular and plural
          forms of the terms.
        </p>

        <p>
          <strong>"Account"</strong> Means any deposit, custodial, payment, or
          transaction account established for you at the Bank through Icon,
          including any subaccounts, card accounts, settlement accounts, funding
          accounts, payroll accounts, or other accounts governed by this
          Agreement.
        </p>

        <p>
          <strong>"Account Owner" / "Customer" / "You" / "Your"</strong> Means
          (i) an employer establishing an Account to facilitate payroll deposits
          or employee benefits; (ii) an advisory client of Icon establishing an
          advised Account; and (iii) any business entity or individual that has
          opened or is authorized to use an Account.
        </p>

        <p>
          References to "you" and "your" include actions taken by your
          Authorized Users and Authorized Representatives on your behalf, and
          you are responsible for all such actions as if they were your own.
        </p>

        <p>
          <strong>"ACH"</strong> means the Automated Clearing House network and
          the rules established by the National Automated Clearing House
          Association ("NACHA"), including any successor rules or entities.
        </p>

        <p>
          <strong>"Affiliate"</strong> means, with respect to any party, any
          entity that directly or indirectly controls, is controlled by, or is
          under common control with that party.
        </p>

        <p>
          <strong>"Agreement"</strong> means this User Agreement, including all
          schedules, disclosures, addenda, rate sheets, supplemental terms,
          updates, and amendments.
        </p>

        <p>
          <strong>"Applicable Law"</strong> means all applicable federal, state,
          and local laws, regulations, rules, ordinances, regulatory guidance,
          court orders, and obligations imposed by governmental or regulatory
          authorities, including but not limited to the BSA, AML laws, OFAC
          regulations, FDIC regulations, NACHA rules, Regulation E, Regulation
          DD, and UCC Articles 3, 4, and 4A.
        </p>

        <p>
          <strong>"Authorized User" / "Authorized Representative"</strong> means
          any person you designate or permit (whether intentionally or
          negligently) to access your Account, initiate transactions, receive
          statements, or act on your behalf.
        </p>

        <p>
          <strong>"Bank"</strong> means Cross River Bank, Member FDIC ("CRB"),
          including its successors and permitted assigns, acting as the
          financial institution holding your Account.
        </p>

        <p>
          <strong>"BSA/AML Laws"</strong> means the Bank Secrecy Act, the USA
          PATRIOT Act, FinCEN regulations, anti-money-laundering laws, sanctions
          programs, and all other applicable financial crimes prevention laws.
        </p>

        <p>
          <strong>"Business Day"</strong> means Monday through Friday, excluding
          federal holidays and any day on which the Bank is not open for
          processing.
        </p>

        <p>
          <strong>"Chargeback"</strong> means a reversal of funds resulting from
          disputes, returns, invalid transactions, insufficient authorization,
          or any other reason permitted by applicable rules.
        </p>

        <p>
          <strong>"Compliance Review"</strong> means any investigation or
          evaluation conducted by the Bank or Icon relating to fraud, suspicious
          activity, sanctions, regulatory requirements, or other legal
          obligations.
        </p>

        <p>
          <strong>"Disbursement"</strong> means any payment, ACH debit, ACH
          credit, transfer, wire transfer, or other withdrawal from your
          Account.
        </p>

        <p>
          <strong>"EFT" or "Electronic Fund Transfer"</strong> means a transfer
          to or from your Account, as that term is defined by Regulation E (12
          CFR Part 1005). An EFT includes an ACH transaction but does not
          include a Wire Transfer.
        </p>

        <p>
          <strong>"Electronic Communication"</strong> means any notice,
          disclosure, statement, record, authorization, or other communication
          provided by electronic means, including e-mail, website posting, App
          notification, SMS text, or dashboard message.
        </p>

        <p>
          <strong>"FDIC Insurance"</strong> means federal deposit insurance
          coverage up to applicable limits under the Federal Deposit Insurance
          Act, subject to pass-through eligibility requirements.
        </p>

        <p>
          <strong>"Funds Availability Policy"</strong> means the Bank's funds
          availability rules, including hold periods for deposits, ACH entries,
          mobile check deposits, wires, and other items.
        </p>

        <p>
          <strong>"Icon"</strong> means The Icon Savings Corporation, including
          its employees, contractors, service providers, subsidiaries, and
          affiliates including Icon Financial Services LLC ("IFS"), which is an
          SEC Registered Investment Advisor.
        </p>

        <p>
          <strong>"Indemnified Party(ies)"</strong> means Icon, the Bank, their
          Affiliates, and each of their directors, officers, employees, agents,
          service providers, contractors, and assigns.
        </p>

        <p>
          <strong>"KYC" / "KYB"</strong> means "Know Your Customer" and "Know
          Your Business" verification processes used to authenticate identity,
          ownership structure, business legitimacy, and regulatory risk.
        </p>

        <p>
          <strong>"Legal Process"</strong> means any subpoena, levy,
          garnishment, restraining order, warrant, forfeiture action, asset
          freeze, information request, regulatory order, or other
          government-issued instruction.
        </p>

        <p>
          <strong>"OFAC"</strong> means the U.S. Department of the Treasury's
          Office of Foreign Assets Control, including its sanctions lists and
          regulations.
        </p>

        <p>
          <strong>"Participant" or "Employee Participant"</strong> means any
          employee or individual for whom an employer initiates deposits or
          payroll-related transactions through Icon's platform.
        </p>

        <p>
          <strong>"Payment Instruction"</strong> means any authorization,
          request, file, transaction, or command to transfer, withdraw, credit,
          debit, or otherwise move funds in your Account.
        </p>

        <p>
          <strong>"Personal Information"</strong> means any information about an
          identifiable individual, including data regulated under GLBA, state
          privacy laws, and federal privacy requirements.
        </p>

        <p>
          <strong>"Security Credentials" or "Access Credentials"</strong> means
          login credentials, passwords, account numbers, tokens, authentication
          codes, biometric identifiers, API keys, or any other means used to
          access your Account.
        </p>

        <p>
          <strong>"Security Incident" or "Security Breach"</strong> means any
          unauthorized access, use, or disclosure of Account data, personal
          information, or transaction data.
        </p>

        <p>
          <strong>"Service Provider"</strong> means any third party engaged by
          Icon or the Bank to provide services, including processors, cloud
          providers, verification partners, KYC vendors, and card networks.
        </p>

        <p>
          <strong>"Statement"</strong> means electronic statements reflecting
          Account activity, fees, holds, and balances.
        </p>

        <p>
          <strong>"Transaction"</strong> means any deposit, transfer, payment,
          card transaction, debit, credit, or posting to your Account.
        </p>

        <p>
          <strong>"User"</strong> means any person who accesses the Account or
          Icon's platform, whether as an Authorized User, employee,
          representative, or participant.
        </p>

        <p>
          <strong>"Website"</strong> means any website or mobile web application
          provided by Icon that allows access to your Account. Icon's website
          for business-owned accounts is specifically meant to mean
          employer.iconsavingsplan.com. Icon's website for individually-owned
          accounts is specifically meant to mean my.iconsavingsplan.com.
        </p>

        <p>
          <strong>"Wire Transfer"</strong> means an electronic transfer of funds
          through a wire service, such as SWIFT, the Federal Reserve Wire
          Network, or the Clearing House Interbank Payments System.
        </p>

        <h2>II. General Account Terms</h2>

        <h3>A. About Us</h3>

        <p>
          <strong>A.1. Cross River Bank.</strong> This Account is provided by
          Cross River Bank.
        </p>

        <p>
          <strong>A.2. Icon.</strong> Icon's services are offered through the
          Icon website. If you have registered a username, passphrase, or mobile
          device to access Your Account (i.e., your Access Credentials), you may
          log in to your Account using the Website at any time to view and
          update information about your Account and initiate online transfers.
          Your use of the Icon website is subject to the Terms and Conditions of
          Icon. The terms of this Agreement govern in the event there is a
          conflict between the Terms and Conditions of the Icon website and this
          Agreement.
        </p>

        <p>
          <strong>A.3. Contact Us.</strong> You may contact us through the
          website chat function in Icon or email us at
          support@iconsavingsplan.com on business days, to ask questions or
          request information. Please contact us at any time whenever this
          Agreement or applicable law requires.
        </p>

        <p>
          <strong>A.4. Limited Account Access.</strong> Your Account is an
          electronic demand deposit account that is only accessible through the
          Icon website. You may only make withdrawals from your Account by
          initiating EFT transactions on the Icon website. We will only accept
          deposits into your Account by EFT. You will not be able to make
          withdrawals or deposits at branch locations, by telephone or through
          automated teller machines (ATMs). See the Deposits and Withdrawals,
          Transfers, and Other Account Charges sections for more information.
        </p>

        <p>
          <strong>A.5. Authorization.</strong> You hereby authorize the Bank to
          establish the Account to hold your funds. You are responsible for all
          payments and activities on your Account that are directed through use
          of the Icon website. The Icon website is provided for your sole and
          personal use and you must protect your login credentials. You must not
          share access to your account. If you permit another person to use your
          login credentials, you are responsible for any transactions they
          authorize from your Account. When we receive payment instructions from
          the Icon website it will serve as an authorization for us to debit
          your Account and remit funds on your behalf. You also agree
          transactions effected through the Icon website will be considered
          authorized by the Bank regardless of who entered such instructions
          through the website. With your use of the Icon website, you authorize
          Icon as your sole authorized signatory, to direct Bank at any time to
          charge you for drafts or other orders for the payment of money that
          are drawn on the Account. You further agree that we will not take any
          direction from you with respect to the Account, other than through the
          Icon website and the Bank will direct you to Icon website or
          support@iconsavingsplan.com for any and all activities such as ACH
          transfers and questions related to the Account. Additionally, when you
          open the account and select "I Agree", you electronically sign and
          confirm your authorization for the Bank to debit and credit your
          Account. You understand that your authorizations will remain in effect
          until you revoke your authorization, which you can do by writing to us
          as described in Section A.3.
        </p>

        <p>
          <strong>A.6. FDIC Insurance.</strong> Funds in your Account are
          insured by the Federal Deposit Insurance Corporation (FDIC), up to the
          applicable limit. The amount of insurance coverage you have may depend
          on the balance in your Account and the ownership, type of, and
          balances held in any other accounts you have with us. For additional
          information, please visit the FDIC's website at www.fdic.gov. Only
          funds on deposit at the Bank are eligible for FDIC deposit insurance
          and products and services offered by third party service providers
          other than the Bank are not eligible for FDIC insurance.
        </p>

        <h3>B. Opening Your Account</h3>

        <p>
          <strong>B.1. Identifying You.</strong> To help the United States
          Government fight terrorism and money laundering, federal law requires
          us to obtain, verify, and record information that identifies each
          person that opens an Account. What this means for you: when you open
          an Account, we will ask you for your name, street address, email,
          phone number, Social Security Number (SSN), and date of birth. To open
          an Account with us, you must be at least 18 years old, a U.S. citizen
          with a valid SSN and have a residential address in the U.S. or U.S.
          territory where we offer the Account. You may also be required to
          provide a copy of your driver's license or other identifying documents
          that will allow the Bank to identify you.
        </p>

        <p>
          <strong>B.2. Consumer Reporting Agencies.</strong> By submitting an
          application to open an Account, you authorize Icon and the Bank to
          obtain information about you from time to time from consumer reporting
          agencies, check verification services, our subsidiaries and
          affiliates, and other third parties for the purpose of considering
          your Account application or any other purpose permitted by applicable
          law.
        </p>

        <p>
          <strong>B.3. Linking External Accounts.</strong> You may choose to
          link your Account to an account you have with another financial
          institution in the U.S. or a U.S. territory where we offer the
          Account. We will call that other account a Linked External Account.
          Any Linked External Account must be owned by you. Your request to
          establish a Linked External Account is subject to our verification and
          approval. In our discretion, we may limit the number of Linked
          External Accounts you may have at one time or de-link any Linked
          External Account.
        </p>

        <h3>C. Deposits and Transfers</h3>

        <p>
          Deposits may only be made in U.S. dollars, by EFT, including ACH
          transactions. Deposits made by ACH are subject to the NACHA Operating
          Rules and Operating Guidelines and the rules of any regional clearing
          houses we may use from time to time (collectively, the ACH Rules).
          Before final settlement of any deposit, we act only as your agent and
          assume no responsibility beyond the exercise of ordinary care. We
          reserve the right to refuse, return or limit any deposit you make to
          your Account and to establish (and change) maximum dollar limits for
          Account principal balances and transactions in our discretion from
          time to time. By using the Icon website to initiate a transfer of
          funds from a Linked External Account to your Account, you authorize
          Cross River Bank to make the transfer you select on the Icon website.
          If a deposit you make is returned to us unpaid or is otherwise charged
          back to us, we will charge it back to your Account. See the Funds
          Availability Policy section for more information about when you can
          access funds you deposit. Icon may cover the costs of some of these
          services in its sole discretion.
        </p>

        <p>
          All Items are credited subject to final settlement in cash or credits.
          We shall have the right to forward Items to correspondents including
          all Federal Reserve Banks, and we shall not be liable for default or
          neglect of said correspondents for loss in transit, nor shall any
          correspondent be liable except for its own negligence. You
          specifically authorize us or our correspondents including the Federal
          Reserve Banks to handle such Items in accordance with provisions of
          Regulation J (12 CFR Part 210), as revised or amended from time to
          time by the Federal Reserve Board. In the event we are subject to
          local clearinghouse rules, you specifically authorize us to handle
          such Items in accordance with the rules and regulations of the
          clearinghouse.
        </p>

        <p>
          If we permit you to withdraw funds from your Account before final
          settlement has been made for any deposited Item, and final settlement
          is not made, we have the right to charge your Account or obtain a
          refund from you. In addition, we may charge back any deposited Item at
          any time before final settlement for whatever reason. We shall not be
          liable for any damages resulting from the exercise of these rights.
          Except as may be attributable to our lack of good faith or failure to
          exercise ordinary care, we will not be liable for dishonor resulting
          from any reversal of credit, return of deposited Items or for any
          damages resulting from any of those actions.
        </p>

        <p>
          <strong>C.1. Permitted Deposits.</strong> The following types of
          deposits are permitted on your Account only through the Icon website:
        </p>

        <ul>
          <li>
            <strong>Payroll Deduction.</strong> You may choose a paycheck
            contribution amount with your employer to set up automatic,
            recurring transfers to your Account per your direction using the
            Icon website. Use the Icon website to set up, review, change, or
            cancel your transfers.
          </li>
          <li>
            <strong>Other.</strong> We may permit you to make deposits by other
            means, from time to time.
          </li>
        </ul>

        <p>
          <strong>C.2. Deposit Records and Receipts.</strong> We and our service
          providers may rely on the account number on any record of a deposit
          you make, even if that account number is associated with a name that
          is different from the name you've provided. It is not our
          responsibility to detect any inconsistency between the account number
          you provide and the name. You may use the Icon website to confirm that
          we have received a deposit. We will not provide you with notice of our
          receipt of a deposit into your Account. However, all deposits into
          your Account will be included in the periodic statements we provide to
          you. We may confirm your deposits, and, after review, may adjust your
          Account for any errors, including any errors on your deposit, deposit
          request or similar records.
        </p>

        <p>
          <strong>C.3. Our Right to Refuse Deposits.</strong> We may refuse a
          deposit, or part of a deposit, at any time. We also may refuse a
          deposit after initially accepting it. We will not be liable to you for
          refusing a deposit, even if it causes us to decline any transactions
          you have already made.
        </p>

        <p>
          <strong>C.4. When You Can Withdraw Funds You've Deposited.</strong>{" "}
          Please see the Funds Availability Policy section for information about
          when funds you deposit will be available for withdrawal.
        </p>

        <p>
          <strong>C.5. Our Right to Charge Back Deposited Items.</strong> If you
          make a deposit and (a) the sending bank returns it to us unpaid; (b)
          the sending bank demands that we repay them because the deposit was
          unauthorized; or (c) the sending bank or the originator of a transfer
          demands that we return the Item because it was unauthorized, sent to
          the wrong account number or procured by fraud, we may accept the
          return and/or pay the return or demand, and subtract the funds from
          your balance.
        </p>

        <h3>D. Withdrawals</h3>

        <p>
          <strong>D.1. Withdrawals and Transfers from Your Account.</strong>{" "}
          Withdrawals may only be made in U.S. dollars, by EFT initiated only
          through the Icon website, including domestic (United States) ACH
          transactions, by transferring funds to a Linked External Account from
          which you deposited the funds, or other type of account or payee we
          may permit from time to time. We do not permit withdrawals from your
          Account by Wire Transfer. Please see the Electronic Fund Transfer
          Agreement section for more information. By using the Icon website to
          initiate a withdrawal of funds from your Account, you authorize Cross
          River Bank to make the transaction you select on the Icon website.
        </p>

        <p>
          <strong>D.2. Withdrawal Rules.</strong> We may subtract from your
          balance the amount of any withdrawal or debit transaction that you
          initiated or approved. We may require you or any person you authorize
          to provide us with identification, documentation or information that's
          acceptable to us before allowing the transaction. You may not make any
          withdrawal that would exceed the Available Balance in your Account
          (see the Insufficient Funds section below). We may refuse any
          withdrawal by any method we do not specifically permit for your
          Account, that does not include all information we require, or that
          would exceed any applicable frequency or dollar limits or cause your
          Account to be overdrawn. We reserve the right to establish (and
          change) maximum dollar limits for withdrawal transactions from time to
          time.
        </p>

        <p>
          <strong>D.3. Cutoff Time.</strong> Online requests to transfer funds
          to your Account via ACH (i.e., both deposits and withdrawals) must be
          received by us by 2:00 PM Eastern Time on a Business Day to be
          initiated on that Business Day. Online transfer requests received by
          us after 2:00 PM Eastern Time or on a day that is not a Business Day
          generally will be initiated on the next Business Day.
        </p>

        <p>
          <strong>D.4. Account Numbers on Fund Transfers.</strong> If you
          instruct us to send a transfer of funds, such as an EFT, we, our
          service providers, and every other bank involved in the transfer may
          rely on any bank number or account number you provide. If your fund
          transfer instruction gives both a bank number or account number and a
          name, and the name identifies a different person from the bank or
          account owner identified by number, we and other banks that handle the
          fund transfer may still rely exclusively on the number. We have no
          duty to detect any inconsistency between the bank number or account
          number and the name.
        </p>

        <p>
          <strong>D.5. Multiple Signatures.</strong> We are not required to
          comply with any multiple-signature requirement, even if you have
          otherwise instructed us to do so.
        </p>

        <p>
          <strong>D.6. Insufficient Funds.</strong> Our general practice is to
          decline to pay any transaction that would cause a negative balance on
          your Account (i.e., your Available Balance is less than the amount of
          that Item plus all other Items received but not yet paid). However, we
          may, in our sole discretion, pay the Item even if your Available
          Balance is insufficient to cover the transaction, resulting in a
          negative Available Balance. Even if we've paid for such Items before,
          we are not required to do it in the future. We look at your Available
          Balance only once to decide if the Item would cause your Account to
          have a negative balance. If we pay a transaction that causes your
          Account to have a negative balance, you must immediately deposit the
          amount necessary to restore your balance to at least $0.00. We also
          may report you to consumer reporting agencies, close your account, or
          both. This could affect your ability to open accounts with us or other
          banks in the future. You authorize us to use the money from any
          subsequent deposits to your Account to pay any negative balance on
          your Account and restore the balance to at least $0.00. Subsequent
          deposits include any federal or state benefit payments that you choose
          to deposit in your Account (including Direct Deposit of Social
          Security benefits). You understand and agree that if you do not want
          your benefits applied in this way, you may change your Direct Deposit
          instructions at any time. We may still pursue collection of the amount
          you owe (including suing you) after it is charged off.
        </p>

        <p>
          <strong>D.7. Processing Order.</strong> The following processing order
          dictates the order in which we will process your transactions each
          Business Day. All credit transactions are processed first. Debits or
          withdrawals (such as ACH transactions) will be processed in the order
          in which they are received by us. The processing order of these Items
          is important because if your Available Balance is not sufficient to
          pay for each Item in the order it is processed, we may, in our sole
          discretion, return or reject the Item, and your Account may become
          overdrawn.
        </p>

        <p>
          <strong>
            D.8. Fees, Service Charge, Balance Requirements and Expenses.
          </strong>{" "}
          You agree you are responsible for any fees, charges, balance, or
          deposit requirements as stated in this Agreement. You agree to be
          liable to us for any loss, costs or expenses that we incur as a result
          of any dispute involving your Account, including reasonable attorneys'
          fees, to the extent permitted by law, and you authorize us to deduct
          such loss, costs or expenses from your Account without prior notice to
          you.
        </p>

        <h3>E. Communications, Statements, and Notices</h3>

        <p>
          <strong>E.1. Delivery of Notices.</strong> You agree that we and our
          service providers may communicate with you via the Icon website, mail,
          telephone, email, fax, prerecorded message, automated voice, text
          message or other means allowed by law regarding your Account. Any
          legal disclosures, notices and communications and other
          Account-related correspondence that we share with you will be sent via
          email to the last email shown in our records for your Account. Notice
          will be deemed to have been delivered on the day we emailed it to you,
          or made it available electronically. We are not responsible for
          communications or notices lost in, or not delivered by, mail or email.
          Some notices may only be available electronically.
        </p>

        <p>
          <strong>E.2. Electronic Communication.</strong> We may send
          communications electronically, such as by email, text or Icon website
          message, rather than through U.S. Mail or other means, unless the law
          says otherwise. If you give us your email address, you agree that we
          may send servicing messages (such as document notices, fraud alerts,
          and hold alerts) related to your Account to that address. You may be
          required to agree to communicate with us by electronic means in order
          to open an Account. If you revoke your consent to electronic
          communications, we may close your Account or take other action
          described in the E-Sign Consent.
        </p>

        <p>
          <strong>E.3. Telephone Communication.</strong> We may record and/or
          monitor any of our telephone conversations with you. If we do record,
          we do not have to keep the recordings, unless the law says we must.
          When you give us your mobile number, we have your permission to
          contact you at that number about all of your Cross River Bank
          accounts. Your consent allows us and our service providers to use text
          messaging, artificial or prerecorded voice messages and automatic
          dialing technology for informational and service calls, but not for
          telemarketing or sales calls. It may include contact from companies
          working on our behalf to service your Account. Message and data rates
          may apply.
        </p>

        <p>
          <strong>E.4. Change in Contact Information.</strong> We require you to
          provide an email address, mobile telephone number, and physical street
          address (address cannot be a P.O. Box). You are responsible for
          promptly notifying us of any change to any such contact information or
          your name. In some instances, we may request additional information
          for verification purposes. Any notice we mail to you, or email to you,
          will be binding when sent to the last (postal or electronic) address
          in our records. We may change your address if we receive an address
          change notice from the U.S. Postal Service (USPS) or if a company in
          the business of providing correct addresses informs us that the
          address in our records no longer matches your address. Regardless of
          your specified communication preferences we may still provide you
          information via the USPS in some cases.
        </p>

        <p>
          <strong>E.5. Communications Equipment and Services.</strong> You are
          responsible for obtaining and maintaining all telecommunications,
          mobile, broadband, computer, hardware, software, equipment and
          services needed to access and use your Account online; view, save
          and/or print your Account documents online; and receive any messages
          or documents you have consented to receive electronically; and for
          paying all related charges. We are not required to act on any
          instruction or message from you provided by fax, SMS/text, telephone
          voice mail, message service or answering machine. Whenever this
          Agreement or applicable law requires or allows you to give us written
          notice, we will not consider SMS/text or fax to be written notice.
        </p>

        <p>
          <strong>E.6. Periodic Statements.</strong> We will make available a
          periodic statement for your Account. We will make your paperless
          statement available through the Icon website.
        </p>

        <h3>F. Closing or Restricting Your Account</h3>

        <p>
          <strong>
            F.1. Restricting Your Account; Blocking and Delaying Transactions.
          </strong>{" "}
          There are many reasons we may decline or prevent transactions to or
          from your Account, but we generally do it to protect you or us, or to
          comply with legal requirements. We may decline or prevent any or all
          transactions to or from your Account in our sole discretion, as
          permitted by applicable law. We may refuse, freeze, reverse or delay
          any specific withdrawal, payment or transfer of funds to or from your
          Account, or we may remove funds from your Account to hold them pending
          investigation, including, but not limited to, in one or more of the
          following circumstances:
        </p>

        <ul>
          <li>
            You maintain your Account at zero balance for at least 120 days
          </li>
          <li>Your Account is inactive</li>
          <li>
            You relocate outside of the U.S. or any U.S. territory where we
            offer the Account
          </li>
          <li>
            Your Account is involved in any legal or administrative proceeding
          </li>
          <li>
            We receive conflicting information or instructions regarding Account
            ownership, control or activity
          </li>
          <li>
            We suspect that you may be the victim of a fraud, scam or financial
            exploitation, even though you have authorized the transaction(s)
          </li>
          <li>
            We suspect that any transaction may involve illegal activity or may
            be fraudulent
          </li>
          <li>
            We are complying in our sole judgment, with any federal, state or
            local law, rule or regulation, including federal asset control and
            sanction rules and anti-money laundering rules, or with our policies
            adopted to assure that we comply with those laws, rules or
            regulations
          </li>
          <li>
            We reasonably believe that doing so is necessary to avoid a loss or
            reduce risk to us.
          </li>
        </ul>

        <p>
          <strong>F.2. You May Close Your Account.</strong> You may notify us at
          any time to close your Account. However, we are not required to close
          your Account at your request if you have pending transactions, your
          Account is overdrawn or your Account is subject to legal process (such
          as a garnishment, attachment, execution, levy or similar order). In
          those cases, we will restrict your Account against all future
          withdrawals other than under legal process until pending transactions
          are paid or returned, the balance is no longer negative, and any legal
          restriction has been released. If your balance is greater than zero,
          you must disburse all funds. Your Account balance must be $0.00 before
          your Account will be closed. If you request an account closure Icon
          may close all accounts associated with you. If you intend to close
          your Account, you must notify Icon. Simply by reducing your Account
          balance to $0.00 is insufficient notice.
        </p>

        <p>
          <strong>F.3. We May Close Your Account.</strong> We may also close
          your Account at any time, for any reason or no reason, with or without
          prior notice to you. If we close your account, your Account balance
          will be returned to you electronically to a Linked External Account or
          by check sent to you by mail. We will have no liability for any action
          we take under this section.
        </p>

        <p>
          <strong>F.4. Rules for Closing Your Account.</strong> We may restrict
          your Account in preparation for closing. As we do so we may limit
          deposits to, or withdrawals from, your Account. We may send you
          written notice that we have closed or will close your Account and
          return the balance less any fees, claims, setoffs or other amounts.
          This Agreement will survive the closing of your Account and you are
          still responsible for obligations incurred prior to or in connection
          with the closing of your Account. After your Account is closed, we
          have no obligation to accept deposits or pay any outstanding transfer
          requests, but we may reopen your Account if we receive a deposit.
        </p>

        <h3>G. Other Account Terms</h3>

        <p>
          <strong>G.1. Security.</strong> It is your responsibility to protect
          your Access Credentials and the devices on which you access your
          Account. Do not share this information with anyone. Please notify us
          immediately if you believe your Account has been accessed without your
          permission. See the Electronic Fund Transfer Agreement for more
          information about your rights and responsibility in the event of
          unauthorized use of your Account.
        </p>

        <p>
          <strong>G.2. Account Ownership.</strong> Only U.S. citizens may be
          associated with any Account.
        </p>

        <p>
          If you are submitting your application as an individual we will treat
          this Account as an individually-owned account. An individually-owned
          account may not add a joint-owner to your Account.
        </p>

        <p>
          If you are submitting your application as a company, we will treat
          this Account as a business-owned account. By requesting a
          business-owned Account, you acknowledge and agree that you are an
          individual executing this Agreement on behalf of, or for the benefit
          of, any corporation, partnership, or other entity with which you are
          associated, and that you represent and warrant that you have the legal
          authority to bind such organization to this Agreement. Business-owned
          accounts are those established by any partnership, corporation,
          association or other entity operated on a for-profit basis; all
          corporations and associations operated on a not-for-profit-basis; and
          any individual who intends to use the account for carrying on a trade
          or business. This agreement and the relationship between you and the
          Bank is that of debtor and creditor, and neither the Bank nor Icon
          owes any fiduciary duty to you.
        </p>

        <p>
          Business-owned accounts must disclose all beneficial ownership as
          requested by Icon and the Bank. Federal law requires us to help the
          government fight the funding of terrorism and money laundering
          activity by obtaining, verifying, and recording personal information
          that identifies the company associated with any business-owned
          account, and the beneficial owners of the company before you open an
          Account with us. You are responsible for notifying us of any changes
          to the certified beneficial ownership information of the legal entity
          customer that was provided to us. Notice should be made as soon as
          practicable upon a change to the beneficial ownership information in a
          form and manner acceptable to Icon and the Bank.
        </p>

        <p>
          <strong>G.3. Assignment of Agreement and Successors.</strong> You may
          not assign or transfer any interest in your Account unless we agree in
          writing. Any permitted assignment of your Account is subject to our
          setoff rights. This Agreement will be binding on your personal
          representative, executors, administrators and successors, and on our
          successors and assigns.
        </p>

        <p>
          <strong>G.4. Power of Attorney.</strong> A power of attorney is a
          document you sign that authorizes someone else, called the agent, to
          act on your behalf. If you sign a power of attorney, the agent can
          sign on your behalf and do anything you could do regarding your
          Account, including withdrawing or spending all of the money in your
          Account. Do not sign a power of attorney unless you trust the agent to
          act in your best interest. If you choose to add an agent, you must
          provide a power of attorney form that we agree to accept. We may rely
          on a copy of an original power of attorney. We are not required to
          investigate the facts relating to any power of attorney provided to us
          on your behalf, including whether your signature on the power of
          attorney is authentic or whether the agent continues to have
          authority. We may follow or refuse to follow the agent's instructions
          at any time, including if we suspect fraud or abuse on your Account,
          unless applicable law requires otherwise. We may also refuse an
          agent's request to become a joint owner or a beneficiary of an
          Account, but we have no liability to anyone if we do so. We have no
          liability when we follow or refuse to follow any instructions from an
          agent, for example, if your agent misuses the authority you have given
          them.
        </p>

        <p>
          <strong>G.5. Death or Incompetence of Account Owner.</strong> Your
          agent, attorney, personal representative, executor, administrator, or
          successor must tell us immediately if you die or are declared
          incompetent by a court. We may act as if you are alive and competent
          until we receive notice otherwise. After we receive notice of your
          death or incompetence, we may freeze your balance, refuse to accept
          transactions, and reverse or return deposits. We are also not required
          to release your funds until we receive any documents we reasonably
          request to verify your death or incompetence, as well as who is
          entitled to the funds. If you die while residing outside the United
          States, we may require a personal representative to be appointed by a
          court in a United States jurisdiction. If we have any tax liability
          because of paying your balance to your estate, the estate will be
          responsible for repaying us the amount of that tax. If you authorize
          any transaction, but it's not presented for payment until after you
          die or are declared incompetent, we are authorized to pay the
          transaction. If you owe us a debt at the time of your death, we are
          authorized to exercise our right of setoff (our right to apply funds
          in one Account to the debt associated with another Account) or
          security interest rights against the funds credited to your balance
          after your death. We are also not required to disburse funds until we
          receive any documents we reasonably request to verify your death or
          incompetence and to establish a new person's authority to act in
          transacting on or closing your Account.
        </p>

        <p>
          <strong>G.6. Adverse Claims.</strong> If there are conflicting
          instructions or there is any dispute regarding your Account, we may
          take any action described in the Restricting Your Account; Blocking
          and Delaying Transactions section above, or we may place funds with
          the court (this is called an interpleader action) for resolution. If
          any person notifies us of a dispute, we do not have to decide if the
          dispute has merit before we take further action. We may take these
          actions without any liability and without advance notice, unless the
          law says otherwise.
        </p>

        <p>
          <strong>G.7. Setoff and Security Interest.</strong> If you owe a debt
          to us or any of our affiliates (either now or in the future), you
          grant us a right of setoff to, and a security interest in, all of your
          accounts with us to secure the debt. Debts include any fees you owe,
          as well as amounts owed us by another person or entity if you have
          guaranteed that you will pay their debts. If the debt is due or
          overdue, we may use the funds in any of your Accounts to pay all or
          part of the debt. Our security interest will be governed by Uniform
          Commercial Code Article 9 (as adopted by the applicable state law)
          whether Article 9 applies by its terms or not. We do not have to give
          you any prior notice to apply the funds. You expressly agree that our
          rights extend to any electronically deposited federal or state benefit
          payments (including Social Security benefits), as permitted by law. If
          you don't want your benefits applied in this way, you may change your
          Direct Deposit instructions at any time with the person or
          organization paying the benefits. The right of setoff does not apply
          if the debt is created under a personal credit card plan. If any
          federal benefits or other payments are deposited to your Account after
          you become ineligible to receive them, we may set off against any of
          your Accounts to recover the payments if we're obligated to return
          funds to the payor.
        </p>

        <p>
          <strong>G.8. No Waiver.</strong> If we fail to exercise any right,
          that doesn't mean that we waive that right or any other right, and we
          may still enforce all of our rights in the future.
        </p>

        <p>
          <strong>G.9. Changes to the Agreement.</strong> We may change the
          terms of this Agreement, including fees and features of your Account,
          at any time. We will notify you of any such change when required by
          applicable law. Your continued use of your Account evidences your
          agreement to any amendments. Notices will be made available on the
          Icon website or delivered electronically using the most recent contact
          information we have on file for you.
        </p>

        <p>
          <strong>
            G.10. Research, Legal Process and Requests for Information.
          </strong>{" "}
          If we receive any legal process relating to you or your Account, you
          authorize us to comply with it. "Legal process" means any document
          that appears to have the force of law that requires us to hold or pay
          out funds from your Account, including a garnishment, attachment,
          execution, levy or similar order. We do not have to determine whether
          the legal process was validly issued or is enforceable. If any action,
          including administrative proceedings, garnishment, tax levies,
          restraining orders or another action is brought against you or your
          Account, you will be liable to us for any loss, cost or expense
          (including attorneys' fees) resulting from our compliance with any
          legal process. If we receive any subpoena, court order or request for
          information or documents from a government entity or arbitration panel
          relating to your Account, we are authorized to comply with it.
        </p>

        <p>
          <strong>G.11. Illegal Activities and Gambling Transactions.</strong>{" "}
          You may not use your Account for any illegal or unlawful transaction,
          and we may decline to authorize any transaction that we believe poses
          an undue risk of illegality or unlawfulness. We reserve the right to
          place a hold on your Account if we suspect irregular, fraudulent,
          suspicious, unlawful or otherwise unauthorized activity. We may
          attempt to notify you of such a hold but are not required to provide
          notice prior to placing the hold or thereafter. We also may attempt to
          contact you to obtain additional information regarding the activity in
          your Account. We reserve the right to maintain any hold and restrict
          access to the Account until we receive the requested information. You
          agree that we may maintain such hold until all issues, including
          claims against you or us, concerning the funds held in your Accounts
          have been resolved fully to our sole satisfaction. We also reserve the
          right to reject any incoming credit transaction that we suspect is
          involved in fraudulent or suspicious activity. The Bank will not be
          held liable for any loss you incur if your Account is restricted or
          subject to a hold. Notwithstanding the foregoing, we may collect on
          any debt arising out of any illegal or unlawful transaction, to the
          extent permissible under applicable law.
        </p>

        <p>
          You certify that you do not engage in, and during the life of this
          Agreement will not engage in any activity or business that is unlawful
          under the Unlawful Internet Gambling Enforcement Act of 2006, 31
          U.S.C. § 5361, et seq., (the "UIGEA"). You may not use your Accounts
          or any other service we offer to receive, transfer, or credit funds,
          instruments or proceeds that arise out of a business that is unlawful
          under the UIGEA. You agree that if anyone asks us to process a
          transaction that we believe is restricted under the UIGEA, we may
          block the transaction and take any other action we deem to be
          reasonable under the UIGEA and this Agreement. You may not use your
          Account for online gambling or any illegal transactions. Bank may
          refuse to process any transaction that it believes may violate the
          terms of this Agreement or applicable law. You acknowledge and agree
          that the Bank has no obligation to monitor, to review, or to evaluate
          the legality of your transactions. To the fullest extent permitted by
          law, you agree to pay for any transaction that you authorized, even if
          that transaction is determined to be illegal.
        </p>

        <p>
          <strong>G.12. Inactive and Unclaimed Accounts.</strong> Each state has
          laws that govern when accounts are considered inactive or abandoned,
          and when we're required to send a customer's funds to the state. After
          a specified period of time determined by the law of the state of your
          residence (as shown in our records), if we are not able to locate you,
          we will be required to deliver your Account to the state as abandoned
          property. You will then need to apply to the state for return of your
          funds. If your Account is or has been inactive, we may, in our
          discretion, refuse to honor requests for withdrawals on your Account
          until after we have verified that you have authorized the withdrawal
          request.
        </p>

        <p>
          <strong>
            G.13. Reporting to Consumer Reporting Agency; Disputes.
          </strong>{" "}
          We may report information about you or your Account to a consumer
          reporting agency. If you believe that we have reported inaccurate or
          incomplete information about your Account to a consumer reporting
          agency, you have the right to file a dispute with that consumer
          reporting agency. You may also submit a dispute directly to us by
          writing to support@iconsavingsplan.com. Provide your name, address and
          phone number; your Account number; the specific information you are
          disputing; an explanation of why it is inaccurate or incomplete; and
          any supporting documentation.
        </p>

        <p>
          <strong>G.14. Rules Governing Your Account.</strong> We are located in
          New Jersey. We hold your Account in New Jersey. We enter into this
          Agreement with you in New Jersey. Except as otherwise provided in the
          Arbitration section, this Agreement and your Account are subject to
          applicable federal laws and laws of the State of New Jersey, without
          regard to internal principles of conflicts of law. Except as otherwise
          provided in the Arbitration section, if any provision of this
          Agreement is found to be unenforceable according to its terms, all
          remaining provisions will continue in full force and effect.
          Transactions in your Account are also subject to the ACH Rules, other
          applicable clearinghouse and Federal Reserve rules and regulations.
          Changes in these laws may change the terms and conditions of your
          Account. We will notify you of any changes as required by law. If this
          Agreement conflicts with any statements made by one of our employees
          or by a third-party service provider, or Icon, this Agreement will
          govern.
        </p>

        <p>
          <strong>G.15. Limitation of Liability.</strong> You agree that we,
          Icon, our service providers, agents, officers, directors, and
          employees (and the same of our subsidiaries and affiliates and our
          subsidiaries and affiliates themselves) (collectively, the Indemnified
          Parties) will not be liable for anything we do when following your
          instructions. In addition, the Indemnified Parties will not be liable
          if any such Indemnified Party doesn't follow your instructions if we
          reasonably believe that your instructions would expose us to potential
          loss or civil or criminal liability, or conflict with customary
          banking practices. THE INDEMNIFIED PARTIES WILL NOT BE LIABLE FOR
          INDIRECT, SPECIAL, OR CONSEQUENTIAL DAMAGES REGARDLESS OF THE FORM OF
          ACTION AND EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH
          DAMAGES. IF WE FAIL TO STOP PAYMENT ON AN ITEM, OR PAY AN ITEM BEARING
          AN UNAUTHORIZED SIGNATURE, FORGED SIGNATURE, OR FORGED ENDORSEMENT OR
          ALTERATION, OUR LIABILITY, IF ANY, WILL BE LIMITED TO THE FACE AMOUNT
          OF THE ITEM. The foregoing limitation of liability will not apply
          where expressly prohibited by the laws governing your Account. This
          Limitation of Liability section will survive termination of your
          Account.
        </p>

        <p>
          <strong>G.16. Indemnification.</strong> You agree to indemnify and
          hold the Indemnified Parties harmless from and against losses arising
          in connection with the services provided under this Agreement, except
          for losses arising out of our own gross negligence or willful
          misconduct. You further agree to hold the Indemnified Parties harmless
          from losses arising out of actions taken or omitted in good faith by
          us in reliance upon instructions from you. The Indemnified Parties are
          not responsible for any actions or omissions by any third party. If
          you give us instructions that we believe may expose us to potential
          liability, we may refuse to follow your instructions and we will not
          be liable to you if we refuse to follow your instructions. If we do
          choose to follow your instructions, we may ask you for certain
          protections such as a surety bond or an indemnity agreement in a form
          that is satisfactory to us. This Indemnification section will survive
          termination of your Account(s).
        </p>

        <p>
          <strong>G.17. Pre-Judgment Interest Rate.</strong> If either of us is
          awarded a judgment against the other in connection with your Account,
          the rate of interest earned before the judgment on the judgment amount
          will be the rate of interest your Account earned during that period,
          unless a different rate is required by applicable state law.
        </p>

        <p>
          <strong>G.18. Severability.</strong> Any provision of this Agreement
          that limits the Bank's liability does not negate the Bank's duty (if
          any) under applicable law to act in good faith and with reasonable
          care. If any provision of this Agreement is determined to limit the
          Bank's liability in a way prohibited by applicable law, or to be
          otherwise unenforceable, the parties agree to replace such term or
          provision with a term or provision that is valid and enforceable and
          that comes closest to expressing the intention of the invalid or
          unenforceable term or provision, and this Agreement will be
          enforceable as so modified.
        </p>

        <p>
          <strong>G.19. Arbitration.</strong> PLEASE READ THIS SECTION CAREFULLY
          AS IT AFFECTS YOUR RIGHTS. YOU HAVE THE RIGHT TO OPT OUT OF THIS
          ARBITRATION AGREEMENT AS DESCRIBED BELOW
        </p>

        <h4>Agreement to Arbitrate</h4>

        <p>
          This section is referred to as the Arbitration Agreement. If you have
          a dispute with any Indemnified Party, and are not able to resolve the
          dispute informally, you and we agree that upon demand by either you or
          the Indemnified Party, the dispute will be resolved through the
          arbitration process as set forth in this section.
        </p>

        <h4>Arbitration</h4>

        <p>
          You agree that if you have a dispute or claim that has arisen or may
          arise between you and the Bank or any other Indemnified Party, whether
          arising out of or relating to this Agreement (including any alleged
          breach thereof), your Account and services provided under this
          Agreement, any advertising, any aspect of the relationship or
          transactions between us, and you are not able to resolve the dispute
          or claim informally, you and we agree that upon demand by either you
          or the Indemnified Party, the dispute or claim will be resolved
          exclusively through final and binding arbitration, rather than a
          court, in accordance with the terms of this Arbitration Agreement,
          except that you may assert individual claims in small claims court, if
          your claims qualify. Further, this Arbitration Agreement does not
          preclude you from bringing issues to the attention of federal, state,
          or local agencies, and such agencies can, if the law allows, seek
          relief against us on your behalf. You agree that, by entering into
          this Arbitration Agreement, you and the Bank are each waiving the
          right to a trial by jury or to participate in a class action. Your
          rights will be determined by a neutral arbitrator, not a judge or
          jury. The Federal Arbitration Act governs the interpretation and
          enforcement of this Arbitration Agreement.
        </p>

        <h4>Parties Subject to this Arbitration Agreement</h4>

        <p>
          This Arbitration Agreement applies whenever there is a claim between
          you and us. If a third party, such as an Indemnified Party other than
          the Bank, is also involved in a claim between you and us, or if a
          dispute arises between you and an Indemnified Party other than the
          Bank relating to this Agreement or your Account, then the claim will
          be decided with respect to the third party in arbitration as well, in
          accordance with this Arbitration Agreement, and it must be named as a
          party in accordance with the rules of procedure governing the
          arbitration. No award or relief will be granted by the arbitrator
          except on behalf of, or against, a named party.
        </p>

        <h4>Exclusions</h4>

        <p>
          You and we retain the right to pursue in small claims court (or an
          equivalent state court) any dispute that is within that court's
          jurisdiction, so long as the disputes remain in such court and advance
          only an individual claim for relief. If either you or we fail to
          submit to binding arbitration of an arbitrable dispute following
          lawful demand, the party so failing shall bear all costs and expenses
          incurred by the other in compelling arbitration.
        </p>

        <h4>Your Right to Opt Out</h4>

        <p>
          If you do not want this Arbitration Agreement to apply to your
          Account, you may opt out by sending us written notice of your decision
          within thirty (30) days of the opening of your Account. Such notice
          must clearly state that you wish to cancel or opt out of the
          Arbitration Agreement section of this Agreement. It should include
          your name, address, Account name, Account number, and your signature
          and must be mailed to The Icon Savings Corporation, 1631 NE Broadway
          St. #815, Portland, Oregon, 97232. This is the sole and only method by
          which you can opt out of this Arbitration Agreement. Your exercise of
          the right to opt-out will not affect any remaining terms of this
          Agreement and will not result in any adverse consequence to you or
          your Account. You agree that our business records will be final and
          conclusive evidence with respect to whether you cancelled or opted out
          of this Arbitration Agreement in a timely and proper fashion.
        </p>

        <h4>
          Prohibition of Class and Representative Actions and Non-Individualized
          Relief
        </h4>

        <p>
          YOU AGREE THAT YOU MAY BRING CLAIMS AGAINST THE BANK OR INDEMNIFIED
          PARTY ONLY ON AN INDIVIDUAL BASIS AND NOT AS A PLAINTIFF OR CLASS
          MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE ACTION OR PROCEEDING.
          UNLESS BOTH YOU AND THE BANK AGREE OTHERWISE, THE ARBITRATOR MAY NOT
          CONSOLIDATE OR JOIN MORE THAN ONE PERSON'S OR PARTY'S CLAIMS AND MAY
          NOT OTHERWISE PRESIDE OVER ANY FORM OF A CONSOLIDATED, REPRESENTATIVE,
          OR CLASS PROCEEDING. ALSO, THE ARBITRATOR MAY AWARD RELIEF (INCLUDING
          MONETARY, INJUNCTIVE, AND DECLARATORY RELIEF) ONLY IN FAVOR OF THE
          INDIVIDUAL PARTY SEEKING RELIEF AND ONLY TO THE EXTENT NECESSARY TO
          PROVIDE RELIEF NECESSITATED BY THAT PARTY'S INDIVIDUAL CLAIM(S),
          EXCEPT THAT YOU MAY PURSUE A CLAIM FOR AND THE ARBITRATOR MAY AWARD
          PUBLIC INJUNCTIVE RELIEF UNDER APPLICABLE LAW TO THE EXTENT REQUIRED
          FOR THE ENFORCEABILITY OF THIS PROVISION.
        </p>

        <h4>Pre-Arbitration Dispute Resolution</h4>

        <p>
          The Bank and Indemnified Parties are always interested in resolving
          disputes amicably and efficiently, and most customer concerns can be
          resolved quickly and to the customer's satisfaction through the Icon
          website or by email to support@iconsavingsplan.com. If such efforts
          prove unsuccessful, a party who intends to seek arbitration must first
          send to the other, by certified mail, a written Notice of Dispute
          (Notice). The Notice to the Bank or Indemnified Party should be sent
          to The Icon Savings Corporation, 1631 NE Broadway St. #815, Portland,
          Oregon, 97232 (Notice Address). The Notice must (a) describe the
          nature and basis of the claim or dispute and (b) set forth the
          specific relief sought. If you do not resolve the claim with the Bank
          or Indemnified Party within 60 calendar days after the Notice is
          received, you or the Bank or Indemnified Party, as applicable, may
          commence an arbitration proceeding. During the arbitration, the amount
          of any settlement offer made by any party will not be disclosed to the
          arbitrator until after the arbitrator determines the amount, if any,
          to which you or the Bank is entitled.
        </p>

        <h4>Arbitration Procedures</h4>

        <p>
          Arbitration will be conducted by a neutral arbitrator in accordance
          with the American Arbitration Association's (AAA) rules and
          procedures, including the AAA's Consumer Arbitration Rules
          (collectively, the AAA Rules), as modified by this Arbitration
          Agreement. For information on the AAA, please visit its website,
          http://www.adr.org. Information about the AAA Rules and fees for
          consumer disputes can be found at the AAA's consumer arbitration page,
          http://www.adr.org/consumer_arbitration. If there is any inconsistency
          between any term of the AAA Rules and any term of this Arbitration
          Agreement, the applicable terms of this Arbitration Agreement will
          control unless the arbitrator determines that the application of the
          inconsistent Arbitration Agreement terms would not result in a
          fundamentally fair arbitration. The arbitrator must also follow the
          provisions of the Agreement as a court would. All issues are for the
          arbitrator to decide, including, but not limited to, issues relating
          to the scope, enforceability, and arbitrability of this Arbitration
          Agreement. Although arbitration proceedings are usually simpler and
          more streamlined than trials and other judicial proceedings, the
          arbitrator can award the same damages and relief on an individual
          basis that a court can award to an individual under the Agreement and
          applicable law. Decisions by the arbitrator are enforceable in court
          and may be overturned by a court only for very limited reasons.
        </p>

        <p>
          Unless the parties to the arbitration agree otherwise, any arbitration
          hearings will take place in a reasonably convenient location for both
          parties with due consideration of their ability to travel and other
          pertinent circumstances. If the parties are unable to agree on a
          location, the determination will be made by AAA. If your claim is for
          $10,000 or less, you may choose whether the arbitration will be
          conducted solely on the basis of documents submitted to the
          arbitrator, through a telephonic hearing, or by an in-person hearing
          as established by the AAA Rules. If your claim exceeds $10,000, the
          right to a hearing will be determined by the AAA Rules. Regardless of
          the manner in which the arbitration is conducted, the arbitrator will
          issue a reasoned written decision sufficient to explain the essential
          findings and conclusions on which the award is based.
        </p>

        <h4>Costs of Arbitration</h4>

        <p>
          Payment of all filing, administration, and arbitrator fees
          (collectively, the Arbitration Fees) will be governed by the AAA
          Rules, unless otherwise provided in this Arbitration Agreement. If the
          value of the relief sought is $75,000 or less, at your request, the
          Bank will pay all Arbitration Fees. If the value of relief sought is
          more than $75,000 and you are able to demonstrate to the arbitrator
          that you are economically unable to pay your portion of the
          Arbitration Fees or if the arbitrator otherwise determines for any
          reason that you should not be required to pay your portion of the
          Arbitration Fees, the Bank will pay your portion of such fees. In
          addition, if you demonstrate to the arbitrator that the costs of
          arbitration will be prohibitive as compared to the costs of
          litigation, the Bank will pay as much of the Arbitration Fees as the
          arbitrator deems necessary to prevent the arbitration from being
          cost-prohibitive. Any payment of attorneys' fees will be governed by
          the AAA Rules.
        </p>

        <h4>Confidentiality</h4>

        <p>
          All aspects of the arbitration proceeding, and any ruling, decision,
          or award by the arbitrator, will be strictly confidential for the
          benefit of all parties.
        </p>

        <h4>Severability</h4>

        <p>
          If a court or the arbitrator decides that any term or provision of
          this Arbitration Agreement (other than the Prohibition of Class and
          Representative Actions and Non-Individualized Relief section above) is
          invalid or unenforceable, the parties agree to replace such term or
          provision with a term or provision that is valid and enforceable and
          that comes closest to expressing the intention of the invalid or
          unenforceable term or provision, and this Arbitration Agreement will
          be enforceable as so modified. If a court or the arbitrator decides
          that any of the provisions of the Prohibition of Class and
          Representative Actions and Non-Individualized Relief section are
          invalid or unenforceable, then the entirety of this Arbitration
          Agreement will be null and void, unless such provisions are deemed to
          be invalid or unenforceable solely with respect to claims for public
          injunctive relief. The remainder of the Arbitration Agreement will
          continue to apply.
        </p>

        <h4>Future Changes to Arbitration Agreement</h4>

        <p>
          Notwithstanding any provision in this Agreement to the contrary, if
          the Bank makes any future change to this Arbitration Agreement (other
          than a change to the Notice Address) while you are a user of the
          Services, you may reject any such change by sending the Bank written
          notice within 30 calendar days of the change to the Notice Address
          provided above. By rejecting any future change, you are agreeing that
          you will arbitrate any dispute covered by this Arbitration Agreement
          in accordance with the language of this Arbitration Agreement as of
          the date you first accepted the Agreement (or accepted any subsequent
          changes to the Agreement).
        </p>

        <h2>III. Truth In Savings Disclosure</h2>

        <p>
          <strong>Rate Information.</strong> Your Account will not earn
          interest.
        </p>

        <p>
          <strong>Determination Of Rate.</strong> At our discretion, we may
          change the interest rate on your Account.
        </p>

        <p>
          <strong>Frequency Of Rate Changes.</strong> We may change the interest
          rate on your Account at any time.
        </p>

        <p>
          <strong>Limitations On Rate Changes.</strong> There are no maximum or
          minimum interest rate limits for this Account.
        </p>

        <p>
          <strong>Minimum Balance Requirements.</strong> There are no minimum
          balance requirements to open this Account, avoid fees or to obtain the
          disclosed APY.
        </p>

        <p>
          <strong>Transaction Limitations.</strong> There are no limits on the
          number or amount of withdrawals or deposits.
        </p>

        <p>
          <strong>Compounding And Crediting.</strong> Interest will be
          compounded on a daily basis and will be credited to your Account
          monthly, as of the last day of the monthly cycle (the interest on the
          last day of the cycle will accrue and post the same day). We only pay
          interest in whole cents. At the end of each monthly cycle, any
          fractional amount of interest accrued that is less than one half of
          one cent will be rounded down to the nearest whole cent, and you will
          forfeit the difference. For example, if $1.044 in interest accrues
          during the monthly cycle, we will credit $1.04 to your Account. Any
          fractional amount of accrued interest equal to one half of one cent or
          more will be rounded up to the nearest whole cent. For example, if
          $1.045 in interest accrues during a monthly cycle, we will credit
          $1.05 to your Account.
        </p>

        <p>
          <strong>Balance Computation Method.</strong> We use the daily balance
          method to calculate interest on your Account. This method applies a
          daily periodic rate to every end-of-day balance in your Account for
          the period. The daily rate is calculated by using an actual/365-day
          count convention. The end-of-day balance is calculated by adding the
          principal and accrued interest.
        </p>

        <p>
          <strong>Accrual On Noncash Deposits.</strong> Interest begins to
          accrue no later than the Business Day we receive credit for the
          deposit of noncash Items.
        </p>

        <p>
          <strong>Effect Of Closing Account.</strong> If you close your Account
          before interest is credited, you will not receive the accrued
          interest.
        </p>

        <p>
          <strong>Fees And Charges.</strong> Please refer to the separate Fee
          Schedule provided to you with this Agreement for information about
          fees and charges associated with this Account. A Fee Schedule will be
          provided to you at the time you open an Account, periodically when
          fees or charges change, and upon request.
        </p>

        <h2>IV. Fee Schedule</h2>

        <p>
          <strong>Business Accounts.</strong> If a business-owned account incurs
          an ACH Return (as defined by the ACH Rules) Icon may assess a $75
          dollar fee per return. This fee may be assessed or waived at Icon's
          sole discretion.
        </p>

        <p>
          <strong>Individual Accounts.</strong> We do not currently impose any
          fees in connection with your individually-owned Account.
        </p>

        <p>
          <strong>Fee Updates.</strong> Icon reserves the right to add or change
          fees from time to time, and will notify you of any changes to our fees
          and this Fee Schedule, as required by applicable law. In the event the
          Icon website no longer supports access to the Account, we reserve the
          right to add or change fees from time to time, and we will notify you
          of any changes to our fees and this Fee Schedule, as required by
          applicable law. You agree to pay all fees applicable to your Account.
          We may subtract any applicable fees from your balance, even if the
          amount of the fee exceeds the Available Balance in your Account.
        </p>

        <h2>V. Funds Availability Policy</h2>

        <p>
          <strong>Purpose.</strong> The information here describes our policy of
          holding deposited Items in an Account before funds are made available
          to you.
        </p>

        <p>
          <strong>Types of Deposits.</strong> We accept ACH deposits such as ACH
          transfers from a Linked External Account for Payroll Deductions from
          employers, in each case as permitted within the Icon website. We do
          not accept cash or checks for deposit and deposits may not be made in
          person at one of our branches or through an ATM.
        </p>

        <p>
          <strong>Determining the Availability of Your Deposit.</strong> Our
          policy is to delay the availability of funds from your deposits in
          accordance with the provisions set forth below. During such delay, you
          may not access the funds.
        </p>

        <p>
          The length of the delay is counted in Business Days from the day of
          your deposit. Every day is a Business Day except Saturdays, Sundays
          and federal holidays. If you make a deposit before 2:00pm ET on a
          Business Day that we are open, we will consider that day to be the day
          of your deposit. However, if you make a deposit after 2:00pm ET or on
          a day we are not open, we may consider that the deposit was made on
          the next Business Day we are open. The length of the delay varies
          based on the type of deposit and is explained below:
        </p>

        <ul>
          <li>
            <strong>5-Day Availability.</strong> When we (or a third party) are
            authorized to debit funds from an external account (including a
            Linked External Account) and transfer those funds to your Account by
            ACH, the funds will be available on the fifth (5th) Business Day
            after we receive the funds, but may be available earlier.
          </li>
        </ul>

        <p>
          <strong>Your Responsibility for Deposits.</strong> Even if we have
          made funds available to you and you have withdrawn the funds, you are
          still responsible for deposits that are returned to us unpaid and for
          any other problems involving your deposit.
        </p>

        <h2>VI. Electronic Fund Transfer Agreement</h2>

        <p>
          This disclosure contains important information about your use of
          electronic fund transfer ("EFT") services provided by the Bank in
          relation to Accounts established for business-owned accounts, and
          individually-owned accounts. Whenever you accept or authorize EFTs to
          or from your Account, you agree to these terms and conditions, in
          addition to any other applicable limitations in this Agreement
          concerning deposits to and withdrawals from your Account. Please read
          this document carefully and retain it for future reference.
        </p>

        <h3>Types of Available EFTs:</h3>

        <ul>
          <li>
            <strong>Businesses - Online Transfers.</strong> You may use the Icon
            website and request aggregated payroll fund transfers between your
            Account and a Linked External Account.
          </li>
          <li>
            <strong>Individuals - Payroll Allocation.</strong> You may use the
            Icon website to request that your employer allocate part of your pay
            to your Account.
          </li>
        </ul>

        <p>
          <strong>Limits on the Type, Frequency or Amount of EFTs.</strong> For
          security reasons, we may limit the number and dollar amount of
          transfers you can make to an External Account or to third parties.
        </p>

        <h3>Documentation of Your EFTs:</h3>

        <ul>
          <li>
            <strong>Periodic Statements.</strong> You will get a periodic
            paperless statement reflecting credits and debits to your Account,
            including EFTs.
          </li>
          <li>
            <strong>Confirmation.</strong> You may use the Icon website or
            contact us by email at support@iconsavingsplan.com to find out
            whether any EFT you request was successfully completed.
          </li>
        </ul>

        <h3>Preauthorized Payments</h3>

        <p>
          <strong>Right to Stop Payment and Procedure for Doing So.</strong> If
          you have told us in advance to make regular EFT payments out of your
          Account, you can stop any of these payments via the Icon website up to
          24 hours prior to its scheduled time. You can also Call us at
          1-888-544-9451 or email us at support@iconsavingsplan.com in time for
          us to receive your request 2 Business Days or more before the payment
          is scheduled to be made. If you contact us to stop a payment, please
          have the following information ready: your Account number, the date
          the transfer is to be made, to whom the transfer is being made, and
          the amount of the scheduled transfer. If you call, we may also require
          you to put your request in writing and get it to us within 14 days
          after you call.
        </p>

        <p>
          <strong>
            Liability for Failure to Stop Payment of Preauthorized Transfer.
          </strong>{" "}
          If you order us to stop one of these payments 2 Business Days or more
          before the transfer is scheduled and we do not do so, we will be
          liable for your losses or damages. However, there are some exceptions.
          We will not be liable, for instance:
        </p>

        <ul>
          <li>
            If, through no fault of ours, you do not have enough money in your
            Account to make the EFT.
          </li>
          <li>
            If the payroll allocation amounts or periods were incorrectly
            specified by the Account holder.
          </li>
          <li>
            If a system or terminal you use to make an EFT was not working
            properly and you knew about the breakdown when you started the EFT.
          </li>
          <li>
            If circumstances beyond our control (such as fire or flood) prevent
            the transfer despite reasonable precautions that we have taken.
          </li>
          <li>
            There may be other exceptions stated in our Agreement with you.
          </li>
        </ul>

        <h3>In case of errors or questions about your EFTs</h3>

        <p>
          Call us at 1-888-544-9451, write us at 1631 NE Broadway St. #815,
          Portland, Oregon, 97232, or email us at support@iconsavingsplan.com as
          soon as you can, if you think your statement or receipt is wrong or if
          you need more information about a transfer listed on the statement or
          receipt. We must hear from you no later than 60 days after we sent the
          FIRST statement on which the problem or error appeared.
        </p>

        <ul>
          <li>Tell us your name and account number.</li>
          <li>
            Describe the error or the transfer you are unsure about and explain
            as clearly as you can why you believe it is an error or why you need
            more information.
          </li>
          <li>Tell us the dollar amount of the suspected error.</li>
        </ul>

        <p>
          If you tell us orally, we may require that you send us your complaint
          or question in writing within 10 business days. We will determine
          whether an error occurred within 10 business days after we hear from
          you and will correct any error promptly. If we need more time,
          however, we may take up to 45 days to investigate your complaint or
          question. If we decide to do this, we will credit your account within
          10 business days for the amount you think is in error, so that you
          will have the use of the money during the time it takes us to complete
          our investigation. If we ask you to put your complaint or question in
          writing and we do not receive it within 10 business days, we may not
          credit your account.
        </p>

        <p>
          For errors involving new accounts or foreign-initiated transactions,
          we may take up to 90 days to investigate your complaint or question.
          For new accounts, we may take up to 20 business days to credit your
          account for the amount you think is in error.
        </p>

        <p>
          We will tell you the results within three business days after
          completing our investigation. If we decide that there was no error, we
          will send you a written explanation. You may ask for copies of the
          documents that we used in our investigation.
        </p>

        <h3>Notice of your rights and liabilities</h3>

        <p>
          <strong>
            Tell us AT ONCE if you believe that any Access Credentials or device
            you use to access your Account has been lost or stolen, that an EFT
            has been made without your permission, or that someone has
            transferred or may transfer money from your Account without your
            authorization.
          </strong>{" "}
          Emailing is the best way of keeping your possible losses down.{" "}
          <strong>You could lose all the money in your Account.</strong> If you
          tell us within 2 Business Days after you learn of the loss or theft of
          your Access Credentials or device, you can lose no more than $50 if
          someone used your Access Credentials or device to access your Account
          without your permission.
        </p>

        <p>
          If you DO NOT tell us within 2 Business Days after you learn of the
          lost or theft of your Access Credentials or device, and we can prove
          we could have stopped someone from using your Access Credentials or
          device without your permission if you had told us, you could lose as
          much as $500.
        </p>

        <p>
          Also, if your statement shows transfers that you did not make, tell us
          AT ONCE. If you do not tell us within 60 days after the statement was
          made available to you electronically, you may not get back any money
          you lost after the 60 days if we can prove that we could have stopped
          someone from taking the money had you told us in time. If a good
          reason (such as a long trip or a hospital stay) kept you from telling
          us, we will extend the time periods.
        </p>

        <p>
          If you believe your Access Credentials or device have been lost or
          stolen, contact us as soon as possible in the Icon website or by email
          at support@iconsavingsplan.com.
        </p>

        <p>
          <strong>Business Days.</strong> For purposes of this Services
          Agreement, our Business Days are every day except Saturdays, Sundays,
          and federal holidays.
        </p>

        <p>
          <strong>Confidentiality.</strong> We will disclose information to
          third parties about your Account or the EFTs you make:
        </p>

        <ul>
          <li>Where it is necessary for completing EFTs</li>
          <li>
            In order to verify the existence and condition of your Account for a
            third party such as a credit bureau or merchant
          </li>
          <li>In order to comply with government agency or court orders</li>
          <li>If you give us your written permission</li>
        </ul>

        <p>
          <strong>Amendments.</strong> We may change any provision of this
          Electronic Fund Transfer Agreement in our discretion, as permitted by
          law. If we do, we will give you notice if and to the extent required
          by applicable law.
        </p>

        <p>
          <strong>Termination.</strong> We reserve the right to terminate your
          use of any or all of our EFT services for any reason and at any time.
          We will provide you notice before doing so where required by law. You
          also have the right to terminate your use of the EFT services
          described in this Agreement at any time by calling us or writing to
          us. If you call, we may require you to put your request in writing and
          get it to us within 10 Business Days after you call. (Please note that
          SMS/text or online chat notification will not meet the notice
          requirements of this section.) If you terminate your use of our EFT
          services and you have arranged for automatic (regular) transfers
          involving third parties, you are required to inform any third parties
          that the transfers will cease. Any termination of your use of our EFT
          services, whether initiated by you or us, will not affect any of your
          or our rights and obligations under this Agreement that have arisen
          before the effective date of such termination.
        </p>
      </div>
    </>
  );
};

export default CRBAgreement;
